/**
 * @file: formatDuration.ts
 * @copyright: (c) 2019-2021 sichuan zhichetech co., ltd.
 */

import { dateFromValue } from './dateFromValue';

const kSecondsPerHour = 3600;

export const formatDuration = (value: number) => {
  let sec = Math.floor(value / 1000);
  let day = 0,
    hour = 0,
    min = 0;
  day = Math.floor(sec / (kSecondsPerHour * 24));
  sec -= day * (kSecondsPerHour * 24);
  hour = Math.floor(sec / kSecondsPerHour);
  sec -= hour * kSecondsPerHour;
  min = Math.floor(sec / 60);
  sec -= min * 60;

  const components = [];
  if (day) {
    components.push(`${day}天`);
    if (hour) {
      components.push(`${hour}小时`);
    }
  } else if (hour) {
    components.push(`${hour}小时`);
  } else if (min) {
    components.push(`${min}分`);
  } else {
    components.push(`${sec}秒`);
  }
  return components.join('');
};

export const formatDurationTillNow = (timestamp: string | Date | number) => {
  const date = dateFromValue(timestamp);
  return formatDuration(Date.now() - date.getTime());
};

export const formatDurationBetween = (
  a: string | Date | number | undefined,
  b: string | Date | number | undefined,
) => {
  const [x, y] = [dateFromValue(a), dateFromValue(b)];
  return formatDuration(y.getTime() - x.getTime());
};
